import { ApiBaseService } from 'src/app/shared/services/api/api-base/api-base.service';
import { IStoreProps, IListParams } from '../common/common.interface';
import { ICompany } from './company.interface';
import { createStore, setProp, withProps } from '@ngneat/elf';
import { persistState } from '@ngneat/elf-persist-state';
import * as localForage from 'localforage';
import { withPagination } from '@ngneat/elf-pagination';

import {
  getEntity,
  selectAllEntities,
  setEntities,
  withEntities,
} from '@ngneat/elf-entities';
import { Injectable } from '@angular/core';
import * as moment from 'moment';

// eslint-disable-next-line @typescript-eslint/naming-convention
const STORE_NAME = 'companies';

const instance = localForage.createInstance({
  driver: localForage.INDEXEDDB,
  name: 'talent-litmus-adminv2',
  version: 1.0,
  storeName: STORE_NAME,
});

const store = createStore(
  { name: STORE_NAME },
  withProps<IStoreProps>({ lastRefreshed: undefined }),
  withEntities<ICompany, '_id'>({ idKey: '_id' }),
  withPagination(),
);

export const persist = persistState(store, {
  key: STORE_NAME,
  storage: instance,
});

@Injectable()
export class CompanyCoreService {
  private _loading = false;

  /**
   * @name companyList$
   * @description emits stored list of the companies
   */

  companyList$ = store.pipe(selectAllEntities());
  totalCount: number;

  public get loading(): boolean {
    return this._loading;
  }

  constructor(private _api: ApiBaseService) {
    this.refresh();
  }

  public getCompanies(params?: IListParams): void {
    this._loading = true;
    this._api
      .get(`companies/list`, params || {})
      .subscribe((data: ICompanyListResponse) => {
        this.totalCount = data.totalCount;
        store.update(
          setEntities(data.list),
          setProp('lastRefreshed', new Date()),
        );
        this._loading = false;
      });
  }

  public getCompanyInfo(id: string): ICompany {
    const company = store.query(getEntity(id));
    return company;
  }

  public refresh(forced?: boolean): void {
    if (
      forced ||
      !store.value.lastRefreshed ||
      moment().diff(moment(store.value.lastRefreshed), 'minutes') > 60
    ) {
      this.getCompanies();
    }
  }
}

interface ICompanyListResponse {
  list: ICompany[];
  totalCount: number;
}
